/**
 * 客服渠道点击 → 分渠道上报 51（51 不吃属性）。
 */
import { trackAnalyticsLog } from '@/utils/analytics-track';

const SUPPORT_CONTACT_KEY_BY_CHANNEL = Object.freeze({
  email: 'support.contact.email',
  telegram: 'support.contact.telegram',
  livechat: 'support.open',
  tawk: 'support.open',
  bytrack: 'support.open',
});

const SUPPORT_CONTACT_LABEL_BY_CHANNEL = Object.freeze({
  email: '用户点击通过邮箱联系客服',
  telegram: '用户点击通过 Telegram 联系客服',
  livechat: '打开客服入口',
  tawk: '打开客服入口',
  bytrack: '打开客服入口',
});

/**
 * @param {{ channel?: unknown, source?: string }} [input]
 */
export function trackSupportContactClick(input = {}) {
  const channel = String(input.channel ?? '')
    .trim()
    .toLowerCase();
  const key = SUPPORT_CONTACT_KEY_BY_CHANNEL[channel];
  if (!key) return;
  trackAnalyticsLog({
    key,
    label: SUPPORT_CONTACT_LABEL_BY_CHANNEL[channel] || '联系客服渠道',
    value: {
      channel,
      source: input.source || undefined,
    },
  });
}
